import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const authSlice = createSlice({
	name: 'auth',
	initialState: {
		isLoading: false,
		user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '') : null,
		error: undefined,
		success: false,
	},
	reducers: {
		registerUser: (state, action) => {
			if (action.payload.success) {
				state.success = true;
				state.error = undefined;
			} else {
				state.error = action.payload.message;
			}
			state.isLoading = false;
		},

		loginUser: (state, action) => {
			if (action.payload.success) {
				state.user = {
					...action.payload.data,
					token: action.payload.token,
				};
				state.error = undefined;
				localStorage.setItem('user', JSON.stringify(state.user));
			} else {
				// Handle network errors differently - don't show as login errors
				if (action.payload.isNetworkError) {
					state.error = 'Network connection lost. Please check your internet connection.';
				} else {
					state.error = action.payload.message;
				}
			}
			state.isLoading = false;
		},
		setUserIsLoading: (state) => {
			state.isLoading = true;
		},
		setUserSuccess: (state) => {
			state.success = true;
		},
		setUserError: (state, action) => {
			state.error = action.payload;
		},
		resetUserLoading: (state) => {
			state.isLoading = false;
		},
		resetUserError: (state) => {
			state.error = undefined;
		},
		resetUserSuccess: (state) => {
			state.success = false;
		},
		updateUserLocation: (state, action) => {
			if (state.user && state.user.userLocation) {
				state.user.userLocation = {
					...state.user.userLocation,
					...action.payload,
				};
				localStorage.setItem('user', JSON.stringify(state.user));
			}
		},
		updateUserData: (state, action) => {
			if (state.user && action.payload.success) {
				state.user = {
					...state.user,
					...action.payload.data,
					token: state.user.token,
				};
				localStorage.setItem('user', JSON.stringify(state.user));
			}
		},
		logoutUser: (state) => {
			state.isLoading = false;
			state.success = false;
			state.error = undefined;
			state.user = null;
			// Clearing all auth-related data from localStorage
			localStorage.removeItem('user');
			localStorage.removeItem('facit_authUsername');
			localStorage.removeItem('user_token');
			localStorage.removeItem('user_data');
		},
	},
});

export const {
	registerUser,
	loginUser,
	logoutUser,
	updateUserLocation,
	updateUserData,
	setUserIsLoading,
	resetUserLoading,
	setUserError,
	resetUserError,
} = authSlice.actions;

export default authSlice.reducer;
